import { Button, Grid, IconButton } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { MdDelete } from 'react-icons/md'
import { metodoPrograma } from '../../../components/api'
import Table from '../../../components/Table'
import { Shrink } from 'lucide-react'
import { BiRightArrowAlt } from 'react-icons/bi'
import { setError } from '../../../components/alerts'

const retornaPrograma = (u = []) => ({
  idPerfil: u[0],
  dsPerfil: u[3],
  dsContratante: u[1]?.[1],
  dsTipoUsuario: u[2]?.[2],
  dtInclusao: u[4] || '',
  dtEclusao: u[5] || '',
})

const Edicao = ({
  programaAberto,
  setTela,
  setRefreshUsuario,
  tipoUsuario,
  contratanteSelecionado,
}) => {
  const [listaProgramaPermissao, setListaProgramaPermissao] = useState([])
  const [listaPrograma, setListaPrograma] = useState([])

  const salva = async (values) => {
    const res = await metodoPrograma('salva', {
      ...values,
      dsIcone: values.dsIcone?.icone || '',
      idTipoUsuario: tipoUsuario?.[0]?.[0],
      idContratante: contratanteSelecionado?.[0],
    })
    if (res.status) {
      setTela('usuario')
      setRefreshUsuario((prev) => prev + 1)
    } else {
      setError(res.dsErro)
    }
  }

  const excluiPrograma = async (linha) => {
    const dados = {
      idPerfil: linha[0],
      idContratante: linha[1],
      idPrograma: linha[2],
      idTipoUsuario: linha[3],
    }
    await metodoPrograma('excluiProgramaPermissao', dados)
    listaPermissao()
    listarPrograma()
  }

  const adicionaPrograma = async (linha) => {
    const dados = {
      idPerfil: linha[0],
      idContratante: linha[1],
      idPrograma: linha[2],
      idTipoUsuario: linha[3],
    }
    await metodoPrograma('adicionaProgramaPermissao', dados)
    listaPermissao()
    listarPrograma()
  }

  const listaPermissao = useCallback(async () => {
    const dados = {
      idPerfil: programaAberto[0],
      idContratante: programaAberto[1][0][0],
      idTipoUsuario: programaAberto[2][0][0],
    }
    const res = await metodoPrograma('listaProgramaPermissao', dados)
    setListaProgramaPermissao(res.lista || [])
  }, [programaAberto, setListaProgramaPermissao])

  const listarPrograma = useCallback(async () => {
    const dados = {
      idPerfil: programaAberto[0],
      idContratante: programaAberto[1][0][0],
      idTipoUsuario: programaAberto[2][0][0],
    }
    const res = await metodoPrograma('listaPrograma', dados)
    setListaPrograma(res.lista || [])
  }, [programaAberto, setListaPrograma])

  useEffect(() => {
    if (programaAberto?.[0] > 0) {
      listaPermissao()
      listarPrograma()
    }
  }, [listaPermissao, listarPrograma, programaAberto])
  return (
    <Formik
      initialValues={retornaPrograma(programaAberto)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Field
                component={TextField}
                name="dsPerfil"
                label="Descrição"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                InputLabelProps={Shrink}
                name="dsContratante"
                label="Contratante"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                InputLabelProps={Shrink}
                name="dsTipoUsuario"
                label="Tipo Usuário"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                InputLabelProps={Shrink}
                name="dtInclusao"
                label="Inclusão"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Field
                component={TextField}
                InputLabelProps={Shrink}
                name="dtExclusao"
                label="Exclusão"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={() => setTela('usuario')}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            {listaPrograma.length > 0 && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Table
                  dados={listaPrograma}
                  head={['Ícone', 'Título', '']}
                  line={(l) => [l[5], l[4], '']}
                  columnOptions={[
                    {
                      alias: 0,
                      customJsx: ({ linhaOriginal }) => (
                        <IconButton size="small">
                          <i className={linhaOriginal[5]} />
                        </IconButton>
                      ),
                    },
                    {
                      alias: 2,
                      customJsx: ({ linhaOriginal }) => (
                        <IconButton
                          size="small"
                          onClick={() => adicionaPrograma(linhaOriginal)}
                        >
                          <BiRightArrowAlt />
                        </IconButton>
                      ),
                    },
                  ]}
                />
              </Grid>
            )}
            {listaProgramaPermissao.length > 0 && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Table
                  dados={listaProgramaPermissao}
                  head={['Ícone', 'Título', '']}
                  line={(l) => [l[5], l[4], '']}
                  columnOptions={[
                    {
                      alias: 0,
                      customJsx: ({ linhaOriginal }) => (
                        <IconButton size="small">
                          <i className={linhaOriginal[5]} />
                        </IconButton>
                      ),
                    },
                    {
                      alias: 2,
                      customJsx: ({ linhaOriginal }) => (
                        <IconButton
                          size="small"
                          onClick={() => excluiPrograma(linhaOriginal)}
                        >
                          <MdDelete />
                        </IconButton>
                      ),
                    },
                  ]}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
